import * as types from './actionTypes/health-check';
import healthCheckAPI from '../../data/health-check-api';

export interface HealthCheckModel {
  isChecked: boolean,
  status: number
}

export interface IHealthCheckActionType {
  type: typeof types.HEALTH_CHECK_SUCCESS | typeof types.HEALTH_CHECK_FAIL;
  payload: HealthCheckModel;
}

function healthCheckSuccess(data: number) {
  return { type: types.HEALTH_CHECK_SUCCESS, payload: { isChecked: true, status: data, }, error: false, };
}

function healthCheckFail(error) {
  return { type: types.HEALTH_CHECK_FAIL, payload: { isChecked: true, status: error, }, error: true, };
}

export const healthCheck = () => async dispatch => {
  try {
    const response = await healthCheckAPI.healthCheck();
    if (response.errorCode !== -1) {
      return dispatch(healthCheckFail(response.message));
    }
    return dispatch(healthCheckSuccess(200));
  } catch (error) {
    return dispatch(healthCheckFail(error));
  }
};
